import React from "react";
import { Avatar } from "antd";

const UserCell = ({ onSelectUser, selectedSectionId, user }) => {
  return (
    <div
      className={`gx-chat-user-item ${
        selectedSectionId === user.id ? "active" : ""
      }`}
      onClick={() => {
        onSelectUser(user);
      }}
    >
      <div className="gx-chat-user-row">
        <div className="gx-chat-avatar">
          <div className="gx-status-pos">
            <Avatar
              src={user.avatar || require("assets/images/avatar/user.jpg")}
              className="gx-size-40"
              alt={user.receiver_name}
            />
            <span className={`gx-status ${user.status}`} />
          </div>
        </div>

        <div className="gx-chat-contact-col">
          <div className="h4 gx-name" style={{ fontSize: "18px" }}>
            {user.receiver_name}
          </div>
          <div
            className="gx-chat-info-des gx-text-truncate"
            style={{ fontSize: "12px" }}
          >
            {user.mood ? user.mood.substring(0, 40) + "..." : ""}
          </div>
        </div>
      </div>
    </div>
  );
};

const ContactList = ({ onSelectUser, selectedSectionId, contactList }) => {
  return (
    <div className="gx-chat-user">
      {contactList.map((user) => (
        <UserCell
          key={user.id}
          user={user}
          selectedSectionId={selectedSectionId}
          onSelectUser={onSelectUser}
        />
      ))}
    </div>
  );
};

export default ContactList;